// extracted by mini-css-extract-plugin
export default {"container":"zM-z","dimension":"AM-z","dimensionLabels":"BM-z"};